import camelcase from 'camelcase-es5';

const aliases = {
  px: { property: 'padding', specifier: 'xAxis' },
  py: { property: 'padding', specifier: 'yAxis' },
  pt: { property: 'padding', specifier: 'top' },
  pr: { property: 'padding', specifier: 'right' },
  pb: { property: 'padding', specifier: 'bottom' },
  pl: { property: 'padding', specifier: 'left' },
  p: { property: 'padding', specifier: '' },
  mx: { property: 'margin', specifier: 'xAxis' },
  my: { property: 'margin', specifier: 'yAxis' },
  mt: { property: 'margin', specifier: 'top' },
  mr: { property: 'margin', specifier: 'right' },
  mb: { property: 'margin', specifier: 'bottom' },
  ml: { property: 'margin', specifier: 'left' },
  m: { property: 'margin', specifier: '' },
  bg: { property: 'background', specifier: 'color' },
};

export default aliases;

export const pickAlias = (alias: string): string => {
  const propAlias = aliases[alias];
  if (propAlias) {
    return camelcase(`${propAlias.property}-${propAlias.specifier}`);
  }
  return alias;
};
